<template>
  <div class="v-wrapper-ui">
    <slot />
  </div>
</template>
